export const modelsForm: any = {
  modelNo: "",
  Modelname: "",
  description: "",
};
